import { Map as ImmutableMap, Record } from 'immutable';
const ArticleCountsRecord = Record({
  counts: ImmutableMap(),
  error: null,
  isRequesting: false,
  lastLoaded: null
});
export default ArticleCountsRecord;